export function vaccineListForFilter() {
  const query = `{vaccineListForFilter
{id,name}}`;
  return query;
}

export function vaccineListByFilter(filter) {
  let vaccinesId;
  let classesId;
  let studentsId;

  if (filter.vaccines) {
    vaccinesId = filter.vaccines.map((vaccines) => vaccines.id);
  }

  if (filter.classes) {
    classesId = filter.classes.map((classes) => classes.id);
  }

  if (filter.students) {
    studentsId = filter.students.map((students) => students.id);
  }

  const query = `{vaccineListByFilter(filter:{vaccines:[${
    vaccinesId || []
  }], classes:[${classesId || []}], students:[${studentsId || []}], late:${
    filter.late
  }, done:${filter.applied}, pending:${filter.pending} })
{id, studentId, studentName, age,name, description, applicationId, applicationDate, additionalInformation, fileUrl, fileId, appliedBy,  doseId,doseCallendarId, dose, targetAge, classNames }}`;

  return query;
}
export function vaccineRemove(vaccines) {
  const applicationsId = vaccines.map((vaccine) => vaccine.applicationId);

  const mutationQuery = `mutation{
    vaccineRemove(vaccines:[${applicationsId}])
}`;

  return mutationQuery;
}

export function vaccineSave(values) {
  const mutationQuery = `mutation{
    vaccineSave(vaccineApplication:${JSON.stringify(values).replace(
      /"([^(")"]+)":/g,
      '$1:'
    )}){applicationId}
}`;
  return mutationQuery;
}
